/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EvaluationRowSchemaScoreBand = typeof EvaluationRowSchemaScoreBand[keyof typeof EvaluationRowSchemaScoreBand] | null;


export const EvaluationRowSchemaScoreBand = {
  good: 'good',
  partial: 'partial',
  bad: 'bad',
} as const;
